<template>
  <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
    <div class="sign-up-title text-center mb-2">
      Forgot your workspace URL?
    </div>
    <b-row class="justify-content-center mt-5 mb-2">
      <b-col md="12" lg="9">
        <template v-if="!submitted">
          <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
            <b-row class="justify-content-center">
              <b-col md="12" lg="10">
                <h4 class="mb-5 text-center">Enter your email</h4>
                <forgot-workspace-form :submitting="submitting" :state="state" @submit="onSubmit" />
                <h5 class="text-center mt-4"><b-link :to="{ name: 'ConnectToWorkspace' }">Back to sign in</b-link></h5>
              </b-col>
            </b-row>
          </b-card>
        </template>
        <template v-else>
          <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
            <b-row class="justify-content-center">
              <b-col md="10">
                <b-card-title class="sign-up-title text-center">Check your email!</b-card-title>
                <check-email-icon class="ml-0 ml-md-5 mt-2" />
                <h5 class="text-center mt-4"><b-link :to="{ name: 'ConnectToWorkspace' }">Back to sign in</b-link></h5>
              </b-col>
            </b-row>
          </b-card>
        </template>
        <div class="text-center mt-4">
          <h5>Don't have a workspace?</h5>
          <h5><b-link :to="{ name: 'CreateWorkspace' }" class="btn-link-primary">Create one here</b-link></h5>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import ForgotWorkspaceForm from '@/components/forms/ForgotWorkspaceForm.vue'
import CheckEmailIcon from '@/assets/images/checkemail.svg'

export default {
  name: 'ForgotWorkspace',

  data() {
    return {
      state: {},
      submitting: false,
      submitted: false
    }
  },

  methods: {
    onSubmit(data) {
      this.submitting = true
      this.$store.dispatch('forgotCompanyUrl', data.email)
        .then(() => {
          this.submitted = true
        })
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    ForgotWorkspaceForm,
    CheckEmailIcon
  }
}
</script>
